import { render, staticRenderFns } from "./ShopItemModal.vue?vue&type=template&id=78d4fd0e&scoped=true&"
import script from "./ShopItemModal.vue?vue&type=script&lang=js&"
export * from "./ShopItemModal.vue?vue&type=script&lang=js&"
import style0 from "./ShopItemModal.vue?vue&type=style&index=0&id=78d4fd0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d4fd0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VDialog,VIcon,VRow,VSpacer,VTextField})
